import { useCallback } from 'react';
import { useNavigate, NavigateOptions, To } from 'react-router-dom';
import { ViewTransitionType } from '@ui/links/link.types';

type ViewTransitionNavigateOptions = NavigateOptions & {
  viewTransitionType?: ViewTransitionType;
};

/**
 * A wrapper around useNavigate that supports view transitions.
 *
 * @example
 * const navigate = useViewTransitionNavigate();
 *
 * // Navigate with a slide-down transition
 * navigate('../', { relative: 'path', viewTransition: true, viewTransitionType: 'slide-down' });
 */
export function useViewTransitionNavigate() {
  const navigate = useNavigate();

  return useCallback(
    (to: To | number, options?: ViewTransitionNavigateOptions) => {
      if (options?.viewTransitionType) {
        document.documentElement.dataset.viewTransition = options.viewTransitionType;
      }

      if (typeof to === 'number') {
        navigate(to);
      } else {
        navigate(to, options);
      }
    },
    [navigate]
  );
}
